// src/App.js
import './App.css';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

import Home from './page/Home/Home';
import NotFound from './page/NotFound/NotFound';
import PrivateRouter from './Components/PrivateRouter/PrivateRouter';
import Footer from './page/Footer/Footer';
import AuthProvider from './Components/Context/AuthProvider';
import Login from './page/Login/Login';

import Administrative from './page/Administrative/Administrative';

import CustomerOrder from './page/CustomerOrder/CustomerOrder';
import Library from './page/Library/Library';
import SourcingAndPricing from './page/SourcingAndPricing/SourcingAndPricing';

import Moderator from './page/Moderator/Moderator';
import Operator from './page/Operator/Operator';
import Admin from './page/Admin/Admin';

import AdminRouter from './Components/AdminRouter/AdminRouter';
import ModeratorRouter from './Components/ModeratorRouter/ModeratorRouter';
import OperatorRouter from './Components/OperatorRouter/OperatorRouter';
import UserRouter from './Components/UserRouter/UserRouter';
import AdministrativeSystem from './page/AdministrativeSystem/AdministrativeSystem';
import Sales from './page/Sales/Sales';
import Production from './page/Production/Production';
import Hr from './page/Hr/Hr';
import Finance from './page/Finance/Finance';
import NewAdministration from './page/NewAdministration/NewAdministration';
import NewSales from './page/NewSales/NewSales';
import NewProduction from './page/NewProduction/NewProduction';
import NewFinance from './page/NewFinance/NewFinance';
import NewHr from './page/NewHr/NewHr';
import SpaceUpOne from './page/SpaceUpOne/SpaceUpOne';
import SpaceUpTwo from './page/SpaceUpTwo/SpaceUpTwo';
import AdministrativeRouter from './Components/AdministrativeRouter/AdministrativeRouter';
import SalesRouter from './Components/SalesRouter/SalesRouter';
import ProductionRouter from './Components/ProductionRouter/ProductionRouter';
import HrRouter from './Components/HrRouter/HrRouter';
import FinanceRouter from './Components/FinanceRouter/FinanceRouter';
import NewSalesRouter from './Components/NewSalesRouter/NewSalesRouter';
import NewAdministrativeRouter from './Components/NewAdministrativeRouter/NewAdministrativeRouter';
import NewProductionRouter from './Components/NewProductionRouter/NewProductionRouter';
import NewFinanceRouter from './Components/NewFinanceRouter/NewFinanceRouter';
import NewHrRouter from './Components/NewHrRouter/NewHrRouter';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Switch>
            {/* Public */}
            <Route exact path="/">
              <Login />
            </Route>
            <Route exact path="/login">
              <Login />
            </Route>

            {/* Authenticated (any signed-in user) */}
            <PrivateRouter exact path="/home">
              <Home />
            </PrivateRouter>
            <AdministrativeRouter exact path="/files/administrationSystem">
              <AdministrativeSystem></AdministrativeSystem>
            </AdministrativeRouter>
            <SalesRouter exact path="/files/salesSystem">
              <Sales></Sales>
            </SalesRouter>
            <ProductionRouter exact path="/files/productionSystem">
              <Production></Production>
            </ProductionRouter>
            <HrRouter exact path="/files/hrSystem">
              <Hr></Hr>
            </HrRouter>
            <FinanceRouter exact path="/files/financeSystem">
              <Finance></Finance>
            </FinanceRouter>
            <NewAdministrativeRouter exact path="/files/newAdministrationSystem">
              <NewAdministration></NewAdministration>
            </NewAdministrativeRouter>
            <NewSalesRouter exact path="/files/newSalesSystem">
              <NewSales></NewSales>
            </NewSalesRouter>
            <NewProductionRouter exact path="/files/newProductionSystem">
              <NewProduction></NewProduction>
            </NewProductionRouter>
            <NewFinanceRouter exact path="/files/newFinanceSystem">
              <NewFinance></NewFinance>
            </NewFinanceRouter>
            <NewHrRouter exact path="/files/newHrSystem">
              <NewHr></NewHr>
            </NewHrRouter>

            {/* File manager sections (any signed-in user) */}
            <UserRouter exact path="/files/library">
              <Library />
            </UserRouter>
            <UserRouter exact path="/files/sourcingAndPricing">
              <SourcingAndPricing />
            </UserRouter>
            <UserRouter exact path="/files/administrative">
              <Administrative />
            </UserRouter>
            <UserRouter exact path="/files/customerOrder">
              <CustomerOrder />
            </UserRouter>
            <UserRouter exact path="/files/spaceUpOne">
              <SpaceUpOne/>
            </UserRouter>
            <UserRouter exact path="/files/spaceUpTwo">
              <SpaceUpTwo/>
            </UserRouter>
           

            {/* Role-guarded sections */}
            <ModeratorRouter exact path="/moderator">
              <Moderator />
            </ModeratorRouter>

            <OperatorRouter exact path="/operator">
              <Operator />
            </OperatorRouter>

            <AdminRouter exact path="/admin">
              <Admin />
            </AdminRouter>

            {/* 404 */}
            <Route exact path="*">
              <NotFound />
            </Route>
          </Switch>

          <Footer />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
